import { IvrEventType } from 'src/models/Ivrs/IvrSessionContent';
import { linkToIvrRenderer } from 'src/presentation/components/pages/ivrLogs/ivrLogsUtils';

export const EVENT_ID_FIELD = 'event.id';

export const COMMON_FIELDS = [
  { attr: 'event.id', label: 'ID' },
  {
    attr: 'event.ivrId',
    label: 'IVR',
    customRenderer: linkToIvrRenderer,
  },
  { attr: 'event.ivrNodeId', label: 'Node ID' },
];

export const EVENT_DETAILS_FIELDS = {
  [IvrEventType.IVREventStart]: {
    fields: [
      ...COMMON_FIELDS,
      { attr: 'event.sessionType', label: 'Session Type' },
      { attr: 'event.customerNumber', label: 'Customer Number' },
      { attr: 'event.endpointNumber', label: 'Endpoint Number' },
    ],
  },
  [IvrEventType.IVREventDial]: {
    fields: COMMON_FIELDS,
  },
  [IvrEventType.IVREventSchedule]: {
    fields: [...COMMON_FIELDS, { attr: 'event.nextNodeId', label: 'Next Node ID' }],
  },
  [IvrEventType.IVREventEnd]: {
    fields: [...COMMON_FIELDS, { attr: 'event.ivrOutcome', label: 'Outcome Type' }],
  },
  [IvrEventType.IVREventMenu]: {
    fields: [
      ...COMMON_FIELDS,
      { attr: 'event.inputType', label: 'Input Type' },
      { attr: 'event.input', label: 'Input' },
      { attr: 'event.match', label: 'Match' },
      { attr: 'event.success', label: 'Success' },
      { attr: 'event.nextNodeId', label: 'Next Node ID' },
    ],
  },
  [IvrEventType.IVREventNumberMatch]: {
    fields: [
      ...COMMON_FIELDS,
      { attr: 'event.match', label: 'Match' },
      { attr: 'event.matched', label: 'Matched' },
      { attr: 'event.nextNodeId', label: 'Next Node ID' },
    ],
  },
  [IvrEventType.IVREventForward]: {
    fields: [
      ...COMMON_FIELDS,
      { attr: 'event.phoneNumber', label: 'Phone Number' },
      { attr: 'event.extension', label: 'Extension' },
    ],
  },
  [IvrEventType.IVREventMessage]: {
    fields: [...COMMON_FIELDS],
  },
  [IvrEventType.IVREventSchedule]: {
    fields: [...COMMON_FIELDS, { attr: 'event.nextNodeId', label: 'Next Node ID' }],
  },
  [IvrEventType.IVREventSMS]: {
    fields: [
      ...COMMON_FIELDS,
      { attr: 'event.toNumber', label: 'To Number' },
      { attr: 'event.nextNodeId', label: 'Next Node ID' },
    ],
  },
  [IvrEventType.IVREventVoicemail]: {
    fields: [...COMMON_FIELDS],
  },
  [IvrEventType.IVREventHTTP]: {
    fields: [...COMMON_FIELDS, { attr: 'event.nextNodeId', label: 'Next Node ID' }],
  },
  [IvrEventType.IVREventInput]: {
    fields: [...COMMON_FIELDS],
  },
  [IvrEventType.IVREventVariableMatch]: {
    fields: [...COMMON_FIELDS, { attr: 'event.nextNodeId', label: 'Next Node ID' }],
  },
  [IvrEventType.IVREventVariable]: {
    fields: [
      ...COMMON_FIELDS,
      { attr: 'event.success', label: 'Success' },
      { attr: 'event.nextNodeId', label: 'Next Node ID' },
    ],
  },
};
